export const LOGO_URL = "../logo.png";

export const CONTACT = {
  email: "contacto@jarsmart.studio",
  phoneDisplay: "+56 9 7335 1370",
  whatsappNumber: "56973351370",
  whatsappUrl: "https://wa.me/56973351370",
  mailto: "mailto:contacto@jarsmart.studio",
  calendlyUrl: "https://calendly.com/jareliqq-79/30min",
};

export const HERO_BG_IMAGES = [
  {
    src: "../bg_desarrolladores.png?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920",
    alt: "Espacio de trabajo para desarrolladores",
  },
  {
    src: "../turned-gray-laptop.jpg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920",
    alt: "Código de Programación ",
  },
  {
    src: "../binary_code.jpg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920",
    alt: "Código Binario",
  },
];

export const NAV_LINKS = [
  { label: "Servicios", href: "#servicios" },
  { label: "Proceso", href: "#proceso" },
  { label: "Portafolio", href: "#portafolio" },
  { label: "Tecnologías", href: "#tecnologias" },
  { label: "Testimonios", href: "#testimonios" },
  { label: "Contacto", href: "#contacto" },
];

export const SERVICES = [
  {
    key: "web",
    title: "Aplicaciones y Desarrollo Web a Medida",
    description:
      "Aplicaciones web escalables, desde portales corporativos hasta plataformas SaaS complejas SaaS, dashboards y portales internos con UX premium y rendimiento medible, arquitecturas modernas y experiencias de usuario excepcionales.",
    bullets: ["React / Next.js", "Node.js", "Django", "Diseño UI/UX", "Performance"],
    size: "md",
    badge: "Flagship",
  },
  {
    key: "mobile",
    title: "Apps móviles",
    description:
      "Aplicaciones nativas e híbridas para iOS y Android. Diseño intuitivo, rendimiento nativo y sincronización en tiempo real con tus sistemas.",
    bullets: ["React Native", "CI/CD", "Push Notifications", "React Native", "Flutter", "iOS", "Android"],
    size: "sm",
  },
  {
    key: "ai",
    title: "Integraciones IA & Automatización",
    description:
      "Copilotos privados, extracción inteligente de documentos, agentes RAG y automatización de flujos con LLMs de última generación.",
    bullets: ["LLMs privados", "Workflows automatizados", "RAG / Vector DB"],
    size: "md",
  },
  {
    key: "devops",
    title: "Consultoría & DevOps",
    description:
      "Modernización cloud, CI/CD, observabilidad y asesoría CTO para equipos en crecimiento.",
    bullets: ["AWS / GCP", "Kubernetes", "CTO as a Service"],
    size: "sm",
  },
];

export const PROCESS_STEPS = [
  { n: "01", title: "Descubrimiento", text: "Entendemos negocio, usuarios y restricciones. Traducimos ideas en objetivos medibles." },
  { n: "02", title: "Diseño",          text: "Wireframes, UI y arquitectura técnica. Decisiones validadas con prototipos rápidos." },
  { n: "03", title: "Desarrollo",      text: "Sprints semanales con demos, calidad de código y pruebas automatizadas." },
  { n: "04", title: "Entrega",         text: "Release gradual, monitoreo y onboarding de usuarios y equipos internos." },
  { n: "05", title: "Soporte",         text: "Iteración continua, SLAs claros y acompañamiento post-lanzamiento." },
];

export const PORTFOLIO = [
  {
    slug: "Plataforma-b2b",
    title: "Plataforma de Gestión Documental y Certificación B2B",
    tag: "Software a medida",
    description: "Core de certificación y trazabilidad con validación QR, motor dinámico de documentos y panel operativo con analítica en tiempo real.",
    image: "../images/photo-1551288049-bebda4e38f71.jpg",
    metrics: ["-85% tiempo de emisión de certificados", "100% integridad y validación en terreno"],
    year: "2026",
    duration: "4 meses",
    industry: "Seguridad Logística y Equipamiento Minero",
    challenge:
      "El cliente realizaba la emisión de certificados mediante procesos artesanales en Excel y Word. Esto generaba errores críticos en la numeración de folios, falta de trazabilidad histórica y, lo más grave: el riesgo de adulteración de certificados en faenas mineras, ya que no existía una forma de validar la autenticidad del documento en tiempo real.",
    solution:
      "Desarrollamos un ecosistema digital centralizado basado en un Core PHP Nativo de alto rendimiento. Implementamos un motor de generación dinámica de documentos (mPDF) con firmas electrónicas simples e identificación por Código QR único. La solución incluyó un Dashboard de Business Intelligence con métricas de servidor y ventas, además de un portal público de validación que permite a terceros verificar la vigencia de cualquier documento mediante escaneo biométrico.",
    results: [
      "Validación instantánea: Los fiscalizadores en faena pasaron de llamadas telefónicas de verificación a validaciones QR de 2 segundos.",
      "Cero Errores de Trazabilidad: El sistema automatizó la nomenclatura INS/CNF/INF, eliminando la duplicidad de folios al 100%.",
      "Productividad Técnica: La carga administrativa de los técnicos se redujo drásticamente gracias a los formularios dinámicos y autocompletado de clientes.",
      "Inteligencia Comercial: El módulo de vencimientos automáticos permitió a la empresa identificar oportunidades de renovación de contratos con 30 días de antelación.",
    ],
    stack: ["PHP 8.2", "MySQL", "mPDF", "Chart.js", "Bootstrap 5", "JavaScript ES6"],
    testimonial: {
      quote:
        "Pasamos de procesos manuales y riesgosos a una plataforma blindada que escala con nuestro volumen de operación. JARSmartStudio no solo programó un sistema, sino que digitalizó nuestra confianza ante las grandes mineras, ahorrándonos meses de trabajo administrativo.",
      author: "Miguel Olivares.",
      role: "CEO Grupo North Center",
    },
    gallery: [
      "../images/photo-1551288049-bebda4e38f71-1.jpg",
      "../images/photo-1551288049-bebda4e38f71-2.jpg",
    ],
  },
{
    slug: "modernizacion-cloud",
    title: "Digitalización y Validación SGDV",
    tag: "Servicios Industriales & Mantenimiento",
    description: "Digitalización de gestión operativa a plataforma web con automatización de reportes técnicos, validación QR de documentos e inteligencia de datos centralizada.",
    image: "../images/pexels-photo-12902857.png",
    metrics: ["-90% tiempo de gestión", "+100% integridad documental"],
    year: "2025",
    duration: "3 meses",
    industry: "Servicios Industriales & Mantenimiento",
    challenge:
      "Gestión operativa basada en plantillas manuales de Word y Excel dispersas en múltiples computadores. Inexistencia de una base de datos centralizada, lo que impedía la trazabilidad de servicios. El riesgo de adulteración  de certificados era alto, ya que los clientes no tenían una vía rápida para verificar la autenticidad de los documentos entregados en terreno.",
    solution:
      "Desarrollo de una plataforma ERP a medida (SGDV) para la automatización del ciclo de vida del servicio. Implementación de un motor de generación de PDF dinámico con inyección de códigos QR encriptados. Centralización de 4 módulos críticos: Certificados de Operatividad/Mantención, Informes Técnicos con grilla fotográfica auto-ajustable, Cotizaciones con cálculos automáticos en tiempo real y Conformidad de Servicio. Validación pública universal mediante portal seguro.",
    results: [
      "Emisión de documentos pasó de 45 minutos (manual) a menos de 5 minutos (automatizado).",
      "Eliminación total del riesgo de fraude documental gracias a la validación QR en tiempo real.",
      "Visibilidad gerencial completa mediante un dashboard con KPIs de métricas operativas y montos ofertados.",
      "Orden operacional: Centralización de evidencias fotográficas vinculadas directamente a los folios de servicio.",
      "•	Reducción del 95% en errores de cálculo en presupuestos comerciales mediante lógica de backend.",
    ],
    stack: ["PHP 8.2 (Backend Engine)", "MySQL (Relational Database)", "mPDF (High-Precision PDF Rendering)", "JavaScript / Bootstrap 5 (UI/UX Responsivo)", "QR Code Encryption Logic", "Apache Security (.htaccess protection)"],
    testimonial: {
      quote:
        "La implementación del sistema SGDV transformó nuestra operatividad. Pasamos de un desorden de archivos Word a una plataforma blindada donde cada documento emitido respalda nuestra autoridad técnica. Hoy, nuestros clientes validan nuestros servicios con un simple escaneo desde su celular.",
      author: "Jhonny Santos",
      role: "J'Santos SpA",
    },
    gallery: [
      "../images/photo-22202604-abbdajs-04619.jpg",
      "../images/photo-22202604-abbdajs-04619-1.jpg",
    ],
  },
  {
    slug: "sgl-saas-logistica-minera",
    title: "Sistema de Gestión Logística Minera",
    tag: "Transformación Digital",
    description: "Plataforma SaaS para el control documental automatizado, planificación de despachos y facturación (ERP) del transporte en general para la gran minería.",
    image: "../images/photo-105919-0.jpg",
    metrics: ["-70% tiempo administrativo", "100% Continuidad operativa"],
    year: "2026",
    duration: "3 meses",
    industry: "Logística, Transporte y Minería",
    challenge:
      "En el transporte hacia faenas mineras de altos estándares (como Collahuasi), un solo documento vencido (Pase SGCAS, revisión técnica o somnolencia) significa un camión rebotado en garita. Los equipos de operaciones invertían incontables horas cruzando planillas Excel, armando carpetas físicas y persiguiendo firmas, generando cuellos de botella, errores de despacho y exposición a multas millonarias por incumplimiento contractual.",
    solution:
      "Desarrollamos una plataforma en la nube (SaaS Multi-Tenant) con un motor de validación documental inteligente (Semáforo). El sistema bloquea automáticamente la planificación de conductores o equipos que no estén al 100% acreditados. Se integró la autogeneración de Planes de Viaje oficiales (PDV en PDF) con firmas digitales incrustadas, un portal público de acreditación con almacenamiento directo en la nube (Google Drive/Dropbox), y un módulo ERP que valoriza los viajes despachados para generar Estados de Pago exactos.",
    results: [
      "Erradicación de vehículos rechazados en garitas por falta de documentación.",
      "El tiempo para armar y firmar un Plan de Viaje bajó de 15 minutos a 30 segundos.",
      "Digitalización total (Cero Papel) mediante enlaces de acreditación encriptados.",
      "Facturación mensual (EDP) automatizada que evita pérdida de dinero por viajes no cobrados.",
      "El equipo administrativo se enfoca en logística real, no en perseguir papeles.",
    ],
    stack: ["Laravel (PHP)", "MySQL", "DomPDF & Laravel Excel", "Google Drive / Dropbox REST APIs", "Bootstrap 5", "Arquitectura Multi-Tenant"],
    testimonial: {
      quote:
        "El sistema se paga solo con evitar la detención de un solo vehículo en faena. Lo mejor: le quita el error humano al despachador; es matemáticamente imposible enviar a ruta a alguien que no cumpla la ley.",
      author: "Javier Aguilar.",
      role: "Business Development JAR Smart.Studio",
    },
    gallery: [
      "../images/photo-105919-1.jpg",
      "../images/photo-105919-2.jpg",
    ],
  },
];

export const TECH_STACK = [
  "React", "Next.js", "TypeScript", "Node.js", "Python", "FastAPI", 
  "PostgreSQL", "MySQL", "MongoDB", "Redis", "AWS", "GCP", "Docker",
  "Kubernetes", "Terraform", "React Native", "OpenAI", "Claude", "LangChain","Google Cloud",
  
];

export const TESTIMONIALS = [
  {
    quote:
      "Nos entregaron en 3 meses lo que internamente no logramos en un año. El nivel técnico y la claridad del equipo JAR marcan la diferencia.",
    author: "Miguel Olivares M",
    role: "CEO Grupo North Center",
  },
  {
    quote:
      "Pasamos de procesos manuales a una transformación operativa. Hoy nuestros clientes validan nuestros servicios.",
    author: "Jhonny Santos Q.",
    role: "J'Santos SpA.",
  },
  {
    quote:
      "Arquitectura limpia, documentación impecable y un equipo que piensa como socio, no como proveedor.",
    author: "Javier Aguilar R.",
    role: "Business Dev JAR Smart.Studio",
  },
];

export const SERVICE_OPTIONS = [
  "Software a medida",
  "Aplicación web",
  "App móvil",
  "Integración IA / Automatización",
  "Consultoría / DevOps",
  "Otro",
];
